import {findKeyValue} from './../../imports/index.js';
import {decodeTransactionData} from './decodeData.js';
/**
 * Extract logs from data.
 */
export function getLogsFromData(logEntry: Record<string, any>): string[] {
  // Attempt to access logs using a safe optional chain
  const logs = findKeyValue(logEntry,'logs');
  if (Array.isArray(logs)) {
    return logs; // Return logs if valid
  }
  console.error("Logs are not present or invalid in log entry.");
  return []; // Return an empty array as fallback
}
export const extractData = (logs: string[], dataString: string): string[] => {
  if (!Array.isArray(logs)) {
    throw new Error("Logs must be an array of strings.");
  }

  const programData: string[] = logs
    .filter((log: string) => log.includes(dataString))
    .map((log: string) => log.split(dataString)[1])
    .filter((data: string | undefined) => !!data);

  return Array.from(new Set(programData));
};
/**
 * Extracts logs and processes the associated data.
 */
export function getLogs(logs: string): string[] {
  try {
    const parsedLogs = JSON.parse(logs) as string[];
    return Array.isArray(parsedLogs) ? parsedLogs : [];
  } catch {
    return [];
  }
}

/**
 * Retrieves all program invocations from logs.
 */
export function getAllPrograms(logs: string): string[] {
  return getLogs(logs)
    .filter((log) => log.includes('invoke'))
    .map((log) => log.split(' ')[1]);
}
/**
 * Checks if the logs indicate the creation of a mint.
 * @param logs - An array of log strings.
 * @returns A boolean indicating whether "InitializeMint2" instruction is present.
 */
export async function isCreation(logs: string[]): Promise<boolean> {
  for (const log of logs) {
    if (log.includes("Program log: Instruction: InitializeMint2")) {
      console.log('logs:', logs);
      return true;
    }
  }
  return false;
}

/**
 * Extracts the program ID from logs if the "SetAuthority" instruction is followed by an "invoke".
 * @param logs - An array of log strings.
 * @returns The program ID as a string, or undefined if not found.
 */
export async function getProgramId(logs: string[]): Promise<any> {
  let authority = false;

  for (const log of logs) {
    if (authority) {
      if (log.includes("invoke")) {
        return log.split(" ")[1];
      }
    }
    if (log.includes("Program log: Instruction: SetAuthority")) {
      authority = true;
    }
  }

  return undefined;
}
/**
 * Decodes a list of program data iteratively.
 *
 * @param dataList - An array of base64-encoded program data strings.
 * @returns A promise that resolves to an array of decoded objects.
 */
export async function decodeProgramDataList(dataList: string[]): Promise<Record<string, any>[]> {
  const decodedResults: Record<string, any>[] = [];

  for (const programData of dataList) {
    try {
      const decodedData = await decodeTransactionData(programData);
      if (decodedData) {
        decodedResults.push(decodedData);
      } else {
        console.warn("Failed to decode program data:", programData);
      }
    } catch (error) {
      let errorMessage = "Unknown error";
      if (error instanceof Error) {
        errorMessage = error.message;
      }
      console.error("Error decoding program data:", errorMessage);
    }
  }

  return decodedResults;
}
export async function isPairCreation(logs:any){
  if (logs.logs && logs.logs.some((log: any) =>log.includes("Program log: Instruction: InitializeMint2"))) {return true} else {return false} return null;
}